module.exports = __webpack_public_path__ + "img/mobile-menu.49d95983.svg";